module.exports = __webpack_public_path__ + "img/logo.f3662f27.svg";